import words from "../locales/words.json"
import countryCodes from "../jsonDB/countryCodesList.json"

export const appColors = {
    primary: '#1E92C4',
    knaek_linear:'#2DA8DC',
    knaek_title: '#212c41',
    knaek_sub: '#6d7789',
    knaek_input: '#edeff1',
    knaek_lightest: '#E5F2F8',
    knaek_blue: '#5681d3',
    knaek_danger: '#d44f77',
    knaek_alert: '#fbd050',
    secondaryAlt: '#090808',
    border: '#000000',
    inactive: '#c7ced3',
    baseBackground: '#F6F6F7',
    darkBackground: 'rgba(2,56,3,0.4)',
    white: '#FFFFFF',
    light: '#A8B3BA',
    black: '#090808',
    knaek_valid: '#3eba77',
    red: '#FF4500',
    transparent: 'rgba(1,214,132,0.2)',
    gray: '#505050',
}


export const appLocalStoargeValues = {
    userData: 'userData',
    loggedIn: 'loggedIn',
    language: 'language',
}

export const appUrls = {
    backend_api: process.env.REACT_APP_BACKEND_API, //production
    image_url: process.env.REACT_APP_IMAGE_BASE_URL || 'https://img.knaek.com/', // production
    map_url: 'https://goo.gl/maps/HWMYj8s5PfcgEn5Y6/', // Map link
}

export const appRoutes = {
    home: '/',
    features: '/features',
}

export const appLanguage = {
    nl: 'nl',
    en: 'en',
    be: 'be',
}

export const appWords = words


export const internationalDialingCodes = countryCodes


export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        zIndex: '99999 !important', // Replace 9999 with your desired z-index value
        border: 'none', // Remove the border
        boxShadow: 'none', // Remove the box shadow
        '&:hover': {
            border: 'none', // Remove border on hover
        },
        '&:focus': {
            outline: 'none', // Remove outline on focus
            boxShadow: 'none', // Remove box shadow on focus
        },
        backgroundColor: 'transparent',
        margin: 0,
        padding: 0,
        "& .react-select__dropdown-indicator": {
            color: appColors.primary, // Replace "red" with your desired color
        },
    }),
};

export const googlePlayLink= 'https://play.google.com/store/apps/details?id=com.knaek.knaek'
export const appleStoreLink= 'https://apps.apple.com/nl/app/knaek/id547383255?platform=iphone'

export const WEBSITE_TYPE = process.env.REACT_APP_WEBSITE || appLanguage.nl;
